import React, {useState} from 'react';
import LeftPanel from '../components/LeftPanel';
import './Settings.css';
import Loading from '../components/Loading';
import { useCallback } from 'react';
import api from '../contexts/BaseUrl';
import { useEffect } from 'react';
import CrossIcon from '../icons/CrossIcon';
import {Spinner} from 'react-activity'
import "react-activity/dist/Spinner.css";


export default function Settings(){

    const token = JSON.parse(localStorage.getItem('auth')).token;
    const [selectBar, setSelectBar] = useState('sales');
    const [editSalesReport, setEditSalesReport] = useState(0);
    const [editUser, setEditUser] = useState(0);
    const [deleteSalesReport, setDeleteSalesReport] = useState(0);
    const [createSalesReport, setCreateSalesReport] = useState(0);
    const [addNewUser,setAddNewUser] = useState(0);
    const [deleteUser, setDeleteUser] = useState(0);
    const [changeRole, setChangeRole] = useState(0);
    const [passwordReset,setPasswordReset] = useState(0);

    const [isLoading, setIsLoading] = useState(false);
    const [isDeleteLoading, setIsDeleteLoading] = useState(false);
    const [isDeleteError, setIsDeleteError] = useState(false);
    const [isCreateLoading, setIsCreateLoading] = useState(false);
    const [isCreateError, setIsCreateError] = useState(false);
    const [isUserLoading, setIsUserLoading] = useState(false);
    const [isAddNewUserLoading, setIsAddNewUserLoading] = useState(false)
    const [isAddNewUserError, setIsAddNewUserError] = useState(false);
    const [isChangeRoleLoading, setIsChangeRoleLoading] = useState(false)
    const [isChangeRoleError, setIsChangeRoleError] = useState(false);
    const [isPasswordResetLoading, setIsPasswordResetLoading] = useState(false)
    const [isPasswordResetError, setIsPasswordResetError] = useState(false);

    const [pageNumber, setPageNumber] = useState(1);
    const [pagination, setPagination] = useState([]);

    const [allSalesReports, setAllSalesReports] = useState([]);
    const [deleteSalesReportId, setDeleteSalesReportId] = useState(0);

    const [fromDate,setFromDate] = useState('');
    const [toDate, setToDate] = useState('');

    const fromDateObj = fromDate ? new Date(fromDate) : null;
    const toDateObj = toDate ? new Date(toDate) : null;

    const [allUsers, setAllUsers] = useState([]);
    const [deleteUserEmail, setDeleteUserEmail] = useState('')

    const [personName, setPersonName] = useState('');
    const [personEmail,setPersonEmail] = useState('');
    const [personPassword, setPersonPassword] = useState('');
    const [personRole, setPersonRole] = useState('');

    const [changeRoleName, setChangeRoleName] = useState('');
    const [changeRoleEmail, setChangeRoleEmail] = useState('');
    const [currentRole, setCurrentRole] = useState('');
    const [newRole, setNewRole] = useState('');
    const [newPassword, setNewPassword] = useState('');

    const handleSelectBar = (e) => {
        setSelectBar(e.target.value);
        setEditSalesReport(0);
        setEditUser(0);
        fetchAllUsers();
    }

    const handlePageNext = () =>{
        if(pagination.totalPages>pagination.currentPage){
            setPageNumber(pageNumber+1)
        }     
    }

    const handlePagePrevious = () =>{
        if(pageNumber>1){
            setPageNumber(pageNumber-1);
        }
    }

    const showDeleteSale = (e) => {
        setDeleteSalesReportId(e);
        setDeleteSalesReport(1);
    }

    const closeDeleteSale = () => {
        setDeleteSalesReportId(0);
        setDeleteSalesReport(0);
    }

    const closeAddNewUser = () => {
        setPersonRole('');
        setPersonName('');
        setPersonPassword('');
        setPersonEmail('');
        setIsAddNewUserError(false);
        setAddNewUser(0);
    }

    const showDeleteUser = (e) => {
        setDeleteUserEmail(e);
        setDeleteUser(1);
    }

    const closeDeleteUser = () => {
        setDeleteUserEmail('');
        setDeleteUser(0);
    }

    const showChangeRole = (a,b,c) => {
        setChangeRoleName(a);
        setChangeRoleEmail(b);
        setCurrentRole(c);
        setChangeRole(1);
    }

    const closeChangeRole = () => {
        setChangeRoleName('');
        setChangeRoleEmail('');
        setCurrentRole('');
        setNewRole('');
        setChangeRole(0);
    }

    const showResetPassword = (a,b,c) => {
        setChangeRoleName(a);
        setChangeRoleEmail(b);
        setCurrentRole(c);
        setPasswordReset(1);
    }

    const closeResetPassword = () => {
        setChangeRoleName('');
        setChangeRoleEmail('');
        setCurrentRole('');
        setNewPassword('');
        setPasswordReset(0);
    }


    const fetchAllSalesReports = useCallback( async () => {
        setIsLoading(true);
        await api.get(`salesreports/get-sales-reports?pageNumber=${pageNumber}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then(response => {
            setAllSalesReports(response.data);
            setIsLoading(false);
            setPagination(JSON.parse(response.headers.pagination));
        }).catch(err => {
            setIsLoading(false);
        })
    },[token, pageNumber])

    const fetchAllUsers = async () => {
        setIsUserLoading(true);

        await api.get(`accounts/all-users`,{
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then(response => {
            setAllUsers(response.data);
            setIsUserLoading(false);
        }).catch(err => {
            setIsUserLoading(false);
        })
    }

    useEffect(() => {
        fetchAllSalesReports();
    },[fetchAllSalesReports])

    const handleDeleteSalesReport = async () => {
        setIsDeleteLoading(true);
        await api.post(`salesreports/delete-sales-report`,{
            salesReportId: deleteSalesReportId
        },{
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then(response => {
            setDeleteSalesReportId(0);
            fetchAllSalesReports();
            setIsDeleteLoading(false);
            setIsDeleteError(false);
            setDeleteSalesReport(0);
        }).catch(err => {
            setIsDeleteError(true);
            setIsDeleteLoading(false);
        })
    }

    const handleCreateSalesReport = async (e) => {
        e.preventDefault();
        setIsCreateLoading(true);

        await api.post(`salesreports/create-sales-report`, {
            fromDate: fromDateObj,
            toDate: toDateObj
        },{
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then(response => {
            fetchAllSalesReports();
            setIsCreateLoading(false);
            setToDate();
            setFromDate();
            setCreateSalesReport(0);
        }).catch(err => {
            setIsCreateError(true);
            setIsCreateLoading(false);
        })
    }

    const handleAddNewUser = async (e) => {
        e.preventDefault();
        setIsAddNewUserLoading(true);

        await api.post(`accounts/create-account`, {
            name: personName,
            email: personEmail,
            password: personPassword,
            role: personRole
        }, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then(response => {
            fetchAllUsers();
            setPersonName('');
            setPersonEmail('');
            setPersonPassword('');
            setPersonRole('');
            setIsAddNewUserLoading(false);
            setAddNewUser(0);
        }).catch(err => {
            setIsAddNewUserError(true);
            setIsAddNewUserLoading(false);
        })
    }

    const handleDeleteUser = async (e) => {
        setIsDeleteLoading(true);
        await api.post(`accounts/delete-account`, {
            email: deleteUserEmail
        },{
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then(response => {
            fetchAllUsers();
            setDeleteUserEmail('')
            setIsDeleteLoading(false);
            setDeleteUser(0);
        }).catch(err => {
            setIsDeleteError(true);
            setIsDeleteLoading(false);
        })
    }

    const handleChangeRole = async (e) => {
        e.preventDefault();
        setIsChangeRoleLoading(true);
        await api.post(`roles/change-role`, {
            email: changeRoleEmail,
            roleName: newRole
        },{
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then(response => {
            fetchAllUsers();
            setChangeRoleName('');
            setChangeRoleEmail('')
            setCurrentRole('');
            setNewRole('');
            setIsChangeRoleLoading(false);
            setChangeRole(0);
        }).catch(err => {
            setIsChangeRoleError(true);
            setIsChangeRoleLoading(false);
        })
    }

    const handlePasswordReset = async (e) => {
        e.preventDefault();
        setIsPasswordResetLoading(true);
        await api.post(`accounts/manually-reset-password`, {
            email:changeRoleEmail,
            password:newPassword
        }, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then(response => {
            fetchAllUsers();
            setChangeRoleName('');
            setChangeRoleEmail('')
            setCurrentRole('');
            setNewPassword('');
            setIsPasswordResetLoading(false);
            setPasswordReset(0);
        }).catch(err => {
            setIsPasswordResetError(true);
            setIsPasswordResetLoading(false);
        })
    }

    return(
        <div className='settingsPage'>
            <LeftPanel
                tabName='settings'
            />
            <div id='rightPanel'>
                <div id='rightPanelContent'>
                    <div id='barBox'>
                        <select 
                            id='selectBar'
                            onChange={(e) => handleSelectBar(e)}
                            value={selectBar}
                            required
                        >
                            <option value='sales'>Sales Report</option>
                            <option value='users'>All Users</option>
                        </select>
                        {selectBar === 'sales' ?
                        <div>
                            {editSalesReport === 0 ?
                            <button id='editButton' onClick={() => setEditSalesReport(1)}>Edit</button> :
                            <button id='editCancelButton' onClick={() => setEditSalesReport(0)}>Cancel Edit</button>
                            }
                            <button id='addButton' onClick={() => setCreateSalesReport(1)}>Create</button>
                        </div> 
                        :
                        <div>
                            {editUser === 0 ?
                            <button id='editButton' onClick={() => setEditUser(1)}>Edit</button> :
                            <button id='editCancelButton' onClick={() => setEditUser(0)}>Cancel Edit</button>
                            }
                            <button id='addButton' onClick={() => setAddNewUser(1)}>Add User</button>
                        </div>
                        }
                    </div>
                    {
                        selectBar === 'sales' ?
                        <div id='tableBox'>
                            {isLoading ?
                                <Loading /> :
                                <table>
                                    <thead>
                                        <tr>
                                            <th>From</th>
                                            <th>To</th>
                                            <th>Small Pcs</th>
                                            <th>Large Pcs</th>
                                            <th>Total Price</th>
                                            <th>Total Paid</th>
                                            <th>Food Exp.</th>
                                            <th>Market Short</th>
                                            <th>Other Exp.</th>
                                            <th>Total Exp.</th>
                                            <th>Cash In Hand</th>
                                            {editSalesReport === 1 && <th>Actions</th>}  
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {allSalesReports.map((item, index) =>{
                                            return(
                                                <tr key={index}>
                                                    <td>{item.fromDate.substring(0,10)}</td>
                                                    <td>{item.toDate.substring(0,10)}</td>
                                                    <td>{item.totalSmallPieces}</td>
                                                    <td>{item.totalLargePieces}</td>
                                                    <td>{item.totalPrice}</td>
                                                    <td>{item.totalPaid}</td>
                                                    <td>{item.totalFoodExpense}</td>
                                                    <td>{item.totalMarketShort}</td>
                                                    <td>{item.totalOtherExpense}</td>
                                                    <td>{item.totalExpense}</td>
                                                    <td>{item.totalPaid - item.totalOtherExpense}</td>
                                                    {editSalesReport === 1 && <td onClick={() => showDeleteSale(item.salesReportId)} style={{cursor: 'pointer'}}>Delete</td>}
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>    
                                }
                                <div id='pageChangeBox'>
                                    <div id='fixedBox'>
                                        <button id='pageChangeButton' onClick={handlePagePrevious}>Back</button>
                                        
                                        <span>{pageNumber} / {pagination.totalPages}</span>
                                        <button id='pageChangeButton' onClick={handlePageNext}>Next</button>
                                    </div>    
                                    
                                </div>
                        </div> 
                        :
                        <div id='tableBox'>
                            {isUserLoading ?
                                <Loading /> :
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Role</th>
                                            {editUser === 1 && <th>Actions</th>}  
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {allUsers.map((item, index) => {
                                            return(
                                                <tr key={index}>
                                                    <td>{item.user.name}</td>
                                                    <td>{item.user.email}</td>
                                                    <td>{item.roles[0]}</td>
                                                    {editUser ===1 && 
                                                        <td  style={{cursor:'pointer'}}>
                                                            <button id='editDueButton' onClick={() => showChangeRole(item.user.name,item.user.email,item.roles[0])}>Change role</button> 
                                                            <button id='editPasswordButton' onClick={(e) => showResetPassword(item.user.name, item.user.email, item.roles[0])}>Password Reset</button> 
                                                            <button id='addDueButton' onClick={() => showDeleteUser(item.user.email)}>Delete</button> 
                                                        </td>}
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>    
                                }
                        </div>
                    }
                </div>
            </div>
            {
                deleteSalesReport === 1 &&
                <>
                <div id='darkBackground' />
                <div id='modal'>
                    <CrossIcon 
                        size='36'
                        style={{
                            position:'absolute',
                            right:0,
                            cursor:'pointer'
                        }}
                        onClick={closeDeleteSale}
                    />
                    <div id='modalContent'>
                        {isDeleteLoading ?
                        <Loading /> :
                        <>
                           
                            <div id='modalContentDetails'>Are you sure you want to delete <br /> this sales report?</div>
                            <div id='modalButtonBox'>
                                <button onClick={handleDeleteSalesReport} id='YesButton'>Yes</button>
                                <button onClick={closeDeleteSale} id='NoButton'>No</button>
                            </div>
                            {isDeleteError && 
                            <div style={{fontFamily: 'PoppinsMedium', fontSize: 16, color: 'red', textAlign: 'center'}}>Failed deletion! Try again later</div>
                            }
                        </>
                        }
                    </div>
                </div>
                </>
            }

            {
                deleteUser === 1 &&
                <>
                <div id='darkBackground' />
                <div id='modal'>
                    <CrossIcon 
                        size='36'
                        style={{
                            position:'absolute',
                            right:0,
                            cursor:'pointer'
                        }}
                        onClick={closeDeleteSale}
                    />
                    <div id='modalContent'>
                        {isDeleteLoading ?
                        <Loading /> :
                        <>
                           
                            <div id='modalContentDetails'>Are you sure you want to delete <br /> user : {deleteUserEmail}?</div>
                            <div id='modalButtonBox'>
                                <button onClick={handleDeleteUser} id='YesButton'>Yes</button>
                                <button onClick={closeDeleteUser} id='NoButton'>No</button>
                            </div>
                            {isDeleteError && 
                            <div style={{fontFamily: 'PoppinsMedium', fontSize: 16, color: 'red', textAlign: 'center'}}>Failed deletion! Try again later</div>
                            }
                        </>
                        }
                    </div>
                </div>
                </>
            }

            {
                createSalesReport === 1 &&
                <>
                <div id='darkBackground' />
                <div id='modal'>
                    <CrossIcon 
                        size='36'
                        style={{
                            position:'absolute',
                            right:0,
                            cursor:'pointer'
                        }}
                        onClick={() => setCreateSalesReport(0)}
                    />
                    <form id='modalContent' onSubmit={handleCreateSalesReport}>
                    {isCreateError && 
                            <div style={{fontFamily: 'PoppinsMedium', fontSize: 16, color: 'red', textAlign: 'center'}}>Failed creating sales report! Try again later</div>
                            }
                        <div id='dateBox'>
                            <div id='datetitle'>From: </div>
                            <input
                                type='date'
                                required 
                                id='dateInput'
                                onChange={(e) => setFromDate(e.target.value)}
                                value={fromDate}
                            />
                        </div>
                        <div id='dateBox'>
                            <div id='datetitle'>To: </div>
                            <input
                                type='date'
                                required 
                                id='dateInput'
                                onChange={(e) => setToDate(e.target.value)}
                                value={toDate}
                            />
                        </div>
                        {isCreateLoading ?
                        <button id='createButton'><Spinner size={12} color='white' style={{display:'block', margin:'auto'}} /></button> :
                        <button id='createButton'>Create Sales Report</button>}
                        
                    </form>
                </div>
                </>
            }
            {
                addNewUser === 1 &&
                <>
                    <div id='darkBackground' />
                    <div id='modalAddNewUser'>
                        <CrossIcon 
                            size='36'
                            style={{
                                position:'absolute',
                                right:0,
                                cursor:'pointer'
                            }}
                            onClick={closeAddNewUser}
                        />
                        <form id='modalContent' onSubmit={handleAddNewUser}>
                            <div id='modalName'>Add New User</div>
                            <div id='namePhone'>
                                <div id='name'>
                                    <div id='nameTitle'>Name:</div>
                                    <input
                                        id='typeName'
                                        required
                                        placeholder='Type person name'
                                        onChange={(e) => setPersonName(e.target.value)}
                                        value={personName}
                                    />
                                </div>
                                <div id='name'>
                                    <div id='nameTitle'>Email:</div>
                                    <input
                                        id='typeName'
                                        required
                                        placeholder='Type person email'
                                        onChange={(e) => setPersonEmail(e.target.value)}
                                        value={personEmail}
                                    />
                                </div>
                                
                            </div>

                            <div id='namePhone'>
                                <div id='name'>
                                    <div id='nameTitlePassword'>Password:</div>
                                    <input
                                        id='typeNamePassword'
                                        required
                                        placeholder='Type person password'
                                        onChange={(e) => setPersonPassword(e.target.value)}
                                        value={personPassword}
                                    />
                                </div>
                            </div>

                            <div id='namePhone'>
                                <div id='name'>
                                    <div id='nameTitle'>Role:</div>
                                    <select
                                        id='statusSelect'
                                        required
                                        onChange={(e) => setPersonRole(e.target.value)}
                                        value={personRole}
                                    >
                                        <option value=''>Choose role</option>
                                        <option value='Admin'>Admin</option>
                                        <option value='Manager'>Manager</option>
                                    </select>
                                </div>
                            </div>
                            {isAddNewUserError && 
                            <div style={{fontFamily: 'PoppinsMedium', fontSize: 16, color: 'red', textAlign: 'center'}}>Failed adding new user! Try again later</div>
                            }
                            {isAddNewUserLoading ?
                                <button id='addNewUserButton'><Spinner size={12} color='black' style={{display:'block', margin:'auto'}} /></button> :
                                <button id='addNewUserButton'>Add User</button>}
                        </form>
                    </div>
                </>
            }
            {changeRole === 1 &&
                <>
                    <div id='darkBackground' />
                    <div id='modalAddNewUser'>
                        <CrossIcon 
                            size='36'
                            style={{
                                position:'absolute',
                                right:0,
                                cursor:'pointer'
                            }}
                            onClick={closeChangeRole}
                        />
                        <form id='modalContent'  onSubmit={handleChangeRole}>
                            <div id='modalName'>Change Role</div>
                            <div id='namePhone'>
                                <div id='name'>
                                    <div id='nameTitle'>Name:</div>
                                    <div>{changeRoleName}</div>
                                </div>
                            </div>
                            <div id='namePhone'>
                                <div id='name'>
                                    <div id='nameTitle'>Email:</div>
                                    <div>{changeRoleEmail}</div>
                                </div>
                            </div>
                            <div id='namePhone'>
                                <div id='name'>
                                    <div id='nameTitleRole'>Current Role:</div>
                                    <div>{currentRole}</div>
                                </div>
                            </div>
                            <div id='namePhone'>
                                <div id='name'>
                                    <div id='nameTitlePassword'>New Role:</div>
                                    <select
                                        id='statusSelect'
                                        required
                                        onChange={(e) => setNewRole(e.target.value)}
                                        value={newRole}
                                    >
                                        <option value=''>Choose role</option>
                                        <option value='Admin'>Admin</option>
                                        <option value='Manager'>Manager</option>
                                    </select>
                                </div>
                            </div>
                            {isChangeRoleError && 
                            <div style={{fontFamily: 'PoppinsMedium', fontSize: 16, color: 'red', textAlign: 'center'}}>Failed changing role! Try again later</div>
                            }
                            {isChangeRoleLoading ?
                                <button id='addNewUserButton'><Spinner size={12} color='black' style={{display:'block', margin:'auto'}} /></button> :
                                <button id='addNewUserButton'>Update Role</button>}
                        </form>
                    </div>
                </>
            }
            {passwordReset === 1 &&
                <>
                    <div id='darkBackground' />
                    <div id='modalAddNewUser'>
                        <CrossIcon 
                            size='36'
                            style={{
                                position:'absolute',
                                right:0,
                                cursor:'pointer'
                            }}
                            onClick={closeResetPassword}
                        />
                        <form id='modalContent'  onSubmit={handlePasswordReset}>
                            <div id='modalName'>Reset Password</div>
                            <div id='namePhone'>
                                <div id='name'>
                                    <div id='nameTitle'>Name:</div>
                                    <div>{changeRoleName}</div>
                                </div>
                            </div>
                            <div id='namePhone'>
                                <div id='name'>
                                    <div id='nameTitle'>Email:</div>
                                    <div>{changeRoleEmail}</div>
                                </div>
                            </div>
                            <div id='namePhone'>
                                <div id='name'>
                                    <div id='nameTitle'>Role:</div>
                                    <div>{currentRole}</div>
                                </div>
                            </div>
                            <div id='namePhone'>
                                <div id='name'>
                                    <div id='nameTitleNewPasword'>New Password:</div>
                                    <input
                                        id='typeNamePassword'
                                        required
                                        placeholder='Type new password'
                                        onChange={(e) => setNewPassword(e.target.value)}
                                        value={newPassword}
                                    />
                                </div>
                            </div>
                            {isPasswordResetError && 
                            <div style={{fontFamily: 'PoppinsMedium', fontSize: 16, color: 'red', textAlign: 'center'}}>Failed setting new password! Try again later</div>
                            }
                            {isPasswordResetLoading ?
                                <button id='addNewUserButton'><Spinner size={12} color='black' style={{display:'block', margin:'auto'}} /></button> :
                                <button id='addNewUserButton'>Update Password</button>}
                        </form>
                    </div>
                </>
            }
        </div>
    )
}